<template>
  <Markdown :content="data?.markdown || ''" :show-nav="true" />
</template>
<script lang="ts" setup>
import type { IPayloadCmsLegal } from '~/server/api/legal/types';

// ---------------------------------------
// Props
// ---------------------------------------

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
});

// ---------------------------------------
// Hooks
// ---------------------------------------

const router = useRoute()

const { localeProperties } = useI18n();

const {status, error, data } = await useFetch<IPayloadCmsLegal['docs'][number]>(`/api/legal/${props.type}?language_code=${localeProperties.value.language}`,
  {
    key: `legalGet:${router.params.name}:${localeProperties.value.language}`,
    immediate: true,
    default: () => ({}) as any,
  },
);

// ---------------------------------------
// Lifecycles
// ---------------------------------------

useHead({
  title: data.value?.title,
  meta: [
    { content: data.value?.description, name: 'description' },
    { content: data.value?.tags, name: 'keywords' },
  ],
})
</script>
